var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-button",attrs:{"aria-label":"Go back"},on:{"click":_vm.handleBack}},[_c('span',{staticClass:"back-arrow"},[_vm._v("←")]),_c('span',{staticClass:"back-text"},[_vm._v("Back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }